import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'
// 退货原因(前台)
export function getcause(data) {
  return axios.request({
    url: urlObj.crm + 'crm/dictionariesItem/getDictionariesItems',
    method: 'post',
    data
  })
}

// 订单详情(前台)
export function getparticulars(params) {
  return axios.request({
    url: urlObj.wss + `wss-order/sales/after/refund`,
    // url: `http://192.168.0.122:5000/wss-order/afterSale/getOrderById/${params}`,
    method: 'get',
    params
  })
}

// 提交数据 申请退款(前台)
export function presentdata(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/sales/after/refund',
    method: 'post',
    data
  })
}

// 退款金额(前台)
export function salesnumber(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/sales/after/refund/amount',
    // url: 'http://192.168.0.122:5000/wss-order/afterSale/calculationAmount',
    method: 'post',
    data
  })
}

// 退款处理信息 (前台)
export function disposeInfo(params) {
  return axios.request({
    url: urlObj.wss + `wss-order/afterSale/getAfterSaleOrderById/${params}`,
    method: 'get'
  })
}
// 卖家处理退款处理信息 (前台)
export function sellerhandle(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/afterSale/audit',
    method: 'get',
    params
  })
}
// 买家处理退款处理信息 (前台)
export function buyerdispose(params) {
  return axios.request({
    url: urlObj.wss + `wss-order/sales/after/revoke/${params}`,
    method: 'get'
  })
}
// 买家处理退款处理信息 (前台)
export function entirerefund(params) {
  return axios.request({
    url: urlObj.wss + `wss-order/afterSale/fullRefund/${params}`,
    method: 'get'
  })
}
// 字典组
// export function libraysatte(data) {
//   return axios.request({
//     url: urlObj.crm + 'crm/dictionariesItem/getDictionariesItems',
//     method: 'post',
//     data
//   })
// }
